import React, {Component} from 'react';
import ReactGA from 'react-ga';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import './App.css';
import HomepageComponent from './HomepageComponent';
import './general.css';
import RowContent from './RowContent';
import MusicAlgoNav from './MusicAlgoNav';
import MusicAlgoFooter from './MusicAlgoFooter';
import AlgoPage from './AlgoPage';
import App404 from './App404';
import Prerequisites from './Prerequisites'
import Feedback from './Feedback'
//import Page404 from './Page404'
import {Grid, Row, Col, Jumbotron} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import textMap from './algoTexts.jsx';

ReactGA.initialize('UA-75058203-1');
ReactGA.pageview(window.location.pathname + window.location.search);

class App extends Component {
  render() {
    return (
        <div>
            <MusicAlgoNav />
            <Router>

                <div>
                <Switch>

                    <Route path='/(|index.html)/' component={HomepageComponent} />

                    <Route path="/(binary-search.html|binary-search)/"
                        render={ () =>
                            <AlgoPage
                                title={"Binary Search"}
                                textMap={textMap['binary-search']}
                            >
                            </AlgoPage>
                        }
                    >
                    </Route>

                    <Route path='/(bubble-sort.html|bubble-sort)/' 
                        render={ () =>
                            <AlgoPage
                                title={"Bubble Sort"}
                                textMap={textMap['bubble-sort']}
                            >
                            </AlgoPage>
                        }
                    >
                    </Route>

                    <Route path='/(selection-sort.html|selection-sort)/' 
                        render={ () =>
                            <AlgoPage
                                title={"Selection Sort"}
                                textMap={textMap['selection-sort']}
                            >
                            </AlgoPage>
                        }
                    >
                    </Route>

                    <Route path='/(insertion-sort.html|insertion-sort)/' 
                        render={ () =>
                            <AlgoPage
                                title={"Insertion Sort"}
                                textMap={textMap['insertion-sort']}
                            >
                            </AlgoPage>
                        }
                    >
                    </Route>


                    <Route path="/(prerequisites|prerequisites.html)/"
                        render={ () => <Prerequisites/> }>
                    </Route>

{/*<Route path='/feedback' render={() => <Feedback />} />*/} 

                    <Route render={() => <App404/>} />


                
                </Switch>
                </div>
            
            </Router>
            <MusicAlgoFooter />
        </div>
    )    
  }
}
export default App



// WEBPACK FOOTER //
// ./src/App.js